/** @typedef {import("../utils/serviceItemStatus").ServiceItemStatusCode} ServiceItemStatusCode */
import React from "react";
import {SERVICE_ITEM_STATUSES} from "../utils/serviceItemStatus";
import ServiceItemStatusBadge from "./ServiceItemStatusBadge";
import StatusFilter from "../../../shared/components/StatusFilter";

const OPTIONS = SERVICE_ITEM_STATUSES.map(({code}) => ({code, node: <ServiceItemStatusBadge status={code} />}));

/**
 * The service items list's status filter: Ativo / Inativo, in their colors.
 *
 * @param {{
 *   selected: ServiceItemStatusCode[],
 *   onChange: (selected: ServiceItemStatusCode[]) => void,
 * }} props
 */
const ServiceItemStatusFilter = ({selected, onChange}) => (
    <StatusFilter options={OPTIONS} selected={selected} onChange={onChange} />
);

export default ServiceItemStatusFilter;
